import type { LedgerRow } from '@tctp/protocol';

const buyOut = (r: LedgerRow): number => r.buyIns + r.net - r.current;

export function LedgerTable({ ledger, roomId }: { ledger: LedgerRow[]; roomId: string }) {
  const rows = [...ledger].sort((a, b) => b.net - a.net);
  const sum = (f: (r: LedgerRow) => number): number => rows.reduce((n, r) => n + f(r), 0);
  return (
    <>
      <div className="table-scroll">
      <table className="ledger">
        <thead><tr><th>PLAYER</th><th><span className="wide">BUY-IN</span><span className="narrow">IN</span></th><th><span className="wide">BUY-OUT</span><span className="narrow">OUT</span></th><th>STACK</th><th>NET</th></tr></thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.nickname}>
              <td title={r.seated ? 'seated' : 'left the table'}>{r.nickname}</td>
              <td>{r.buyIns}</td><td>{buyOut(r)}</td><td>{r.current}</td>
              <td className={r.net > 0 ? 'pos' : r.net < 0 ? 'neg' : ''}>{r.net > 0 ? `+${r.net}` : r.net}</td>
            </tr>
          ))}
          <tr className="total"><td>TABLE TOTAL</td><td>{sum(r => r.buyIns)}</td><td>{sum(buyOut)}</td><td>{sum(r => r.current)}</td><td /></tr>
        </tbody>
      </table>
      </div>
      <div className="session-foot"><a className="btn green" href={`/api/rooms/${roomId}/ledger.csv`} download>DOWNLOAD</a></div>
    </>
  );
}
